/**
* Checkbox filter for filtering stories and tasks
* @author Christine Movius, Brendan Magee
*/

function CheckboxFilterController($scope, schemaService) {
  $scope.getSchema = schemaService[$scope.schemaMethod];

  const argument = $scope.argument || null;

  $scope.getSchema(argument)
    .then((data) => {
      if (data && Array.isArray(data)) {
        $scope.filterItems = data
          .map((item) => {
            const current = item;
            current.id = item.id.toString();
            return current;
          });

        const [firstItem = {}] = $scope.filterItems;

        if (firstItem.displayOrder !== undefined && firstItem.displayOrder !== null) {
          $scope.filterItems.sort((first, second) => first.displayOrder - second.displayOrder);
        }
      } else {
        $scope.filterItems = [];
      }

      $scope.$watch('filter.value', () => {
        $scope.filterItems.forEach((currentItem) => {
          const item = currentItem;

          if (!$scope.filter.value || !$scope.filter.value.length) {
            item.active = true;
          } else {
            const filterValue = [].concat($scope.filter.value).map(val => val.toString());
            item.active = filterValue.indexOf(item.id) > -1;
          }
        });
      });
    });

  $scope.update = () => {
    const activeFilters = $scope.filterItems.filter(item => item.active);

    if (activeFilters.length && activeFilters.length < $scope.filterItems.length) {
      const updateValue = activeFilters.map(item => item.id.toString());
      $scope.filter.changeValue(updateValue);
    } else {
      $scope.filter.changeValue(null);
    }
  };

  $scope.showOne = item => $scope.filter.changeValue([item.id]);

  $scope.showAll = () => $scope.filter.changeValue(null);
}

const controllerArray = [
  '$scope',
  'schemaService',
  CheckboxFilterController
];

export default function (ngModule) {
  ngModule.controller('CheckboxFilterController', controllerArray);
}
